export var PetTypeIds;
(function (PetTypeIds) {
    PetTypeIds["DOGS"] = "dogs";
    PetTypeIds["CATS"] = "cats";
    PetTypeIds["EXOTICS"] = "exotics";
})(PetTypeIds || (PetTypeIds = {}));
export var createEmptyWeek = function () { return ({
    sunday: null,
    monday: null,
    tuesday: null,
    wednesday: null,
    thursday: null,
    friday: null,
    saturday: null,
}); };
export var createEmptyAddress = function (country) {
    return {
        street: "",
        city: "",
        state: "",
        zipcode: "",
        country: country
    };
};
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASCENDANT"] = "ascendant";
    SortOrder["DESCENDANT"] = "descendant";
    SortOrder["NONE"] = "none";
})(SortOrder || (SortOrder = {}));
export var OWNER_ID = 1;
export var ACCESS_LEVEL_ADMIN_ID = 1;
export var ACCESS_LEVEL_COLLABORATOR_ID = 2;
